/**
 * Loads Hls.js library from CDN
 *
 * @returns {Promise}
 */
export default function loadHls() {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.onerror = reject;
    script.onload = resolve;
    script.src = "https://unpkg.com/hls.js@0.14.15/dist/hls.min.js";
    document.head.appendChild(script);
  });
}
